import installHttp from './http';
import installConfig from './config';
import installImageUtil from './imageUtil';

const injection = {};

export default Object.assign(injection, {
    install(Vue) {
        installHttp(injection, Vue);
        installConfig(injection, Vue);
        installImageUtil(injection, Vue);
        window.injection = injection;
    }
});